<script setup>
const props = defineProps({
    modalId: {
        type: String,
        required: true
    },
    modalTitle: String,
    modalClass: String,
    // submitText: String,
    // dismissText: String,
    loading: {
        type: Number,
        default: 0
    }
});
// const emit = defineEmits(['formSubmit']);

// function onSubmit(event) {
//     if (!props.loading.value) {
//         emit('formSubmit', event);
//     }
//     return false;
// }

</script>

<template>
    <div class="modal fade" :id="modalId" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" :class="modalClass" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ modalTitle }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>
